import { HeidiVersion, type SubscriptionTier } from '@heidi/schema/ml-scribe';

import { isCreditUsageSurfaceTier } from './is-credit-usage-surface-tier';

export function isHeidi2OptInCreditUsageEnabled({
  isHeidi2OptInEnabled,
  heidiVersion,
}: {
  isHeidi2OptInEnabled: boolean;
  heidiVersion: HeidiVersion | null | undefined;
}): boolean {
  return isHeidi2OptInEnabled && heidiVersion === HeidiVersion.Value2;
}

/**
 * Credit-usage surfaces: Clinician Max beta cohort OR an opt-in rollout user who
 * has actually landed on Heidi 2. `heidi_version === 2` alone is not enough —
 * the opt-in flag is the rollout switch for that arm.
 * Shared by the side-nav popover, billing usage row, and launch gate.
 */
export function isCreditUsageSurfaceEnabled({
  isHeidi2OptInEnabled,
  isHeidi2ClinicianMaxBetaEnabled,
  heidiVersion,
}: {
  isHeidi2OptInEnabled: boolean;
  isHeidi2ClinicianMaxBetaEnabled: boolean;
  heidiVersion: HeidiVersion | null | undefined;
}): boolean {
  return (
    isHeidi2ClinicianMaxBetaEnabled ||
    isHeidi2OptInCreditUsageEnabled({ isHeidi2OptInEnabled, heidiVersion })
  );
}

/**
 * Who actually sees a credit-usage surface: the opt-in arm sees it on any tier,
 * the beta cohort only on the credit-usage tiers.
 */
export function isCreditUsageSurfaceEligible({
  isHeidi2OptInEnabled,
  isHeidi2ClinicianMaxBetaEnabled,
  heidiVersion,
  newUserTier,
}: {
  isHeidi2OptInEnabled: boolean;
  isHeidi2ClinicianMaxBetaEnabled: boolean;
  heidiVersion: HeidiVersion | null | undefined;
  newUserTier: SubscriptionTier | null | undefined;
}): boolean {
  return (
    isCreditUsageSurfaceEnabled({
      isHeidi2OptInEnabled,
      isHeidi2ClinicianMaxBetaEnabled,
      heidiVersion,
    }) &&
    newUserTier != null &&
    (isHeidi2OptInCreditUsageEnabled({ isHeidi2OptInEnabled, heidiVersion }) ||
      isCreditUsageSurfaceTier(newUserTier))
  );
}
